/* eslint-disable camelcase */
import { Form, Formik } from 'formik';
import InputText from '../../../components/input-text/inputText';
import ModalComponent from '../../../components/modal/modal';
import ModalBodyComponent from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import { type Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto } from '@wealthlane/api-services/wealthlane-finance-integration-service';
import { FormDivider } from '../system-roles/roles.styled';
import _, { values } from 'lodash';

interface BankAccountType {
  isModalOpen: boolean;
  closeModal: () => void;
  modalLoading: boolean;
  initialData: Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto;
  id?: string;
}

const BankAccountModal = ({
  isModalOpen,
  closeModal,
  initialData,
  modalLoading,
  id,
}: BankAccountType): JSX.Element => {
  return (
    <Formik
      enableReinitialize
      initialValues={initialData}
      onSubmit={() => {
        console.log('here');
      }}>
      <ModalComponent
        show={isModalOpen}
        closeModal={closeModal}
        loading={modalLoading}
        title={'View Bank Account'}
        // valueEdited={_.isEqual(values, initialData)}
        size='lg'
        id={id}
        children={
          <Form id="bankAccountViewForm">
            <ModalBodyComponent id="modalBody">
              <div className='mb-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8' id="bankDetailsGrid">
                <div className='sm:col-span-2 lg:col-span-3' id="verificationTypeSection">
                  <InputText
                    type='text'
                    inputType='View'
                    label='Verification Type'
                    name='verificationType'
                    onChange={null}
                    className='mb-0'
                    disabled
                    id="verificationTypeInput"
                  />
                </div>
                <div className='sm:col-span-2 lg:col-span-3' id="dividerSection">
                  <FormDivider />
                </div>
                {/* <InputText
                  type='text'
                  inputType='View'
                  label='Bank Name'
                  name='institutionName'
                  onChange={null}
                  disabled
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Domiciled in'
                  name='domiciledIn'
                  onChange={null}
                  disabled
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Account Name'
                  name='accountName'
                  onChange={null}
                  disabled
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Account Number'
                  name='accountNumber'
                  onChange={null}
                  disabled
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Routing Number'
                  name='routingNumber'
                  onChange={null}
                  disabled
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Purpose of Bank'
                  name='bankPurpose'
                  onChange={null}
                  disabled
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Status'
                  name='status'
                  onChange={null}
                  disabled
                /> */}
                <InputText
                  type='text'
                  inputType='View'
                  label='Account Holder Name'
                  name='accountName'
                  onChange={null}
                  disabled
                  required
                  id="accountNameInput"
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Account Nick Name'
                  name='accountNickName'
                  onChange={null}
                  disabled
                  required
                  id="accountNickNameInput"
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Routing Type'
                  name='routingType'
                  onChange={null}
                  disabled
                  required
                  id="routingTypeInput"
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Routing Number'
                  name='routingNumber'
                  onChange={null}
                  disabled
                  required
                  id="routingNumberInput"
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Account Type'
                  name='accountType'
                  onChange={null}
                  disabled
                  required
                  id="accountTypeInput"
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Account Number'
                  name='accountNumber'
                  onChange={null}
                  disabled
                  required
                  id="accountNumberInput"
                />

                <InputText
                  type='text'
                  inputType='View'
                  label='Institution Name'
                  name='institutionName'
                  onChange={null}
                  disabled
                  required
                  id="institutionNameInput"
                />
                <InputText
                  type='text'
                  inputType='View'
                  label='Status'
                  name='status'
                  onChange={null}
                  disabled
                  required
                  id="statusInput"
                />
              </div>
            </ModalBodyComponent>
            <ModalFooterComponent
              modalStatus={'View'}
              isEditShow={false}
              onCloseModal={() => {
                closeModal();
              }}
              id="modalFooter"
            // onEditModal={() => setModalStatus('Edit')}
            />
          </Form>
        }
      />
    </Formik>
  );
};

export default BankAccountModal;
